import { useEffect, useState } from 'react';
import { Banner, BlockStack, Button, Card, Checkbox, Text } from '@shopify/polaris';
import { useOutletContext } from 'react-router-dom';
import agent from '../../app/api/agent';

export default function OriginalAppRoutingSettings() {
  const { token } = useOutletContext<{ token: string }>();
  const [status, setStatus] = useState<{ enabled: boolean; ready: boolean; blockers: string[] }>();
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    let current = true;
    void agent.Admin.originalAppRouting(token).then(value => {
      if (current) { setStatus(value); setEnabled(value.enabled); }
    }).catch(() => { if (current) setError('Unable to read new-install routing.'); });
    return () => { current = false; };
  }, [token]);
  const save = async () => {
    setBusy(true); setError('');
    try { const value = await agent.Admin.setOriginalAppRouting(token, enabled); setStatus(value); setEnabled(value.enabled); }
    catch { setError('Routing was not confirmed saved. Reload to check its current state.'); }
    finally { setBusy(false); }
  };
  return <Card><BlockStack gap="300">
    <Text as="h3" variant="headingMd">New installations</Text>
    <Text as="p">Current setting: {status ? status.enabled ? 'PFV2 for new merchants' : 'PFV1 for new merchants' : 'Loading…'}</Text>
    <Checkbox label="Route new installations to PFV2" checked={enabled}
      disabled={!status || busy || (!status.ready && !status.enabled)} onChange={setEnabled} />
    <Text as="p">New merchants receive the embedded PFV2 admin when enabled. Existing merchants and reinstalls keep their assigned version. Turning this off does not move PFV2 stores back to PFV1.</Text>
    {status && !status.ready && <Banner tone="info" title="Activation preparation required">{status.blockers.map(item => <p key={item}>{item}</p>)}</Banner>}
    {error && <Banner tone="critical">{error}</Banner>}
    <Button variant="primary" loading={busy} disabled={!status || enabled === status.enabled || (enabled && !status.ready)} onClick={() => void save()}>Save routing setting</Button>
  </BlockStack></Card>;
}
